export default __webpack_public_path__ + "static/media/mobLogo1.1c942203.svg";